define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MHeightDomain = void 0;
    class MHeightDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MHeightDomain.LessThan5Cm, value: "Less than 5cm" },
                    { key: MHeightDomain._510Cm, value: "5-10cm" },
                    { key: MHeightDomain._1015Cm, value: "10-15cm" },
                    { key: MHeightDomain._1520Cm, value: "15-20cm" },
                    { key: MHeightDomain._2030Cm, value: "20-30cm" },
                    { key: MHeightDomain.MoreThan30Cm, value: "More than 30cm" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MHeightDomain.LessThan5Cm] = 0;
                this.KeyIndex[MHeightDomain._510Cm] = 1;
                this.KeyIndex[MHeightDomain._1015Cm] = 2;
                this.KeyIndex[MHeightDomain._1520Cm] = 3;
                this.KeyIndex[MHeightDomain._2030Cm] = 4;
                this.KeyIndex[MHeightDomain.MoreThan30Cm] = 5;
                this.ValueIndex = {};
                this.ValueIndex["Less than 5cm"] = 0;
                this.ValueIndex["5-10cm"] = 1;
                this.ValueIndex["10-15cm"] = 2;
                this.ValueIndex["15-20cm"] = 3;
                this.ValueIndex["20-30cm"] = 4;
                this.ValueIndex["More than 30cm"] = 5;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MHeightDomain = MHeightDomain;
    Object.defineProperty(MHeightDomain, "LessThan5Cm", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(MHeightDomain, "_510Cm", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(MHeightDomain, "_1015Cm", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(MHeightDomain, "_1520Cm", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(MHeightDomain, "_2030Cm", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(MHeightDomain, "MoreThan30Cm", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(MHeightDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
